import type { OverviewEvent } from "@apphq/shared/types";
import { getOverview } from "../lib/api-admin";

/** System events (auto-linking etc.) come from the overview feed; no dedicated endpoint exists. */
export async function getOverviewEventsForInbox(): Promise<OverviewEvent[]> {
  const o = await getOverview({ period: "30d", environment: "production", vat: "proceeds" });
  return o.events.filter((e) => e.type === "system");
}
